import React, { useContext, useEffect } from "react";
import { createPortal } from "react-dom";
import { useLocation } from "react-router-dom";
import { MobileNotificationContext } from "../Notifications/MobileNotification/MobileNotification";
import { ExpandMoreButton } from "./ExpandMoreButton";
import { CAMPAGIN_PARAMKEY, CAMPAGIN_PARAMVALUE } from "../../constants";
import { useStyles } from "./styled";

export const BackgroundVideoPlayer = ({
  handleClick,
  video: { mp4, webm, poster, mobilePoster },
  hideVideo,
  ...rest
}) => {
  const isMobileNotificationActive = useContext(MobileNotificationContext);
  const classes = useStyles({ isMobileNotificationActive, ...rest });
  const location = useLocation();
  useEffect(() => {
    let paramValue = location.search !== "" && location.search.split("=")[1];
    const params = location.search !== "" && location.search.split("?")[1];
    const paramKey = params && params.length > 0 && params.split("=")[0];
    if (
      location.search !== "" &&
      paramKey === CAMPAGIN_PARAMKEY &&
      paramValue === CAMPAGIN_PARAMVALUE
    ) {
      const timer = setTimeout(() => {
        handleClick();
      }, process.env.AUTO_SCROLL_HOMEPAGE_INTERVAL);
      return () => clearTimeout(timer);
    }
  }, []);
  return createPortal(
    <div className={classes.container}>
      <video
        muted
        id="video-background"
        className={classes.video}
        key={mp4}
        poster={hideVideo ? mobilePoster : poster}
        playsInline={!hideVideo}
        autoPlay={!hideVideo}
        loop={!hideVideo}
      >
        {!hideVideo && (
          <>
            <source src={webm} type="video/webm" />
            <source src={mp4} type="video/mp4" />
          </>
        )}
      </video>

      <div className={classes.buttonContainer}>
        <ExpandMoreButton onClick={handleClick} />
      </div>
    </div>,
    document.getElementById("root")
  );
};
